import { Module } from 'vuex'
import { StateInterface } from '../index'
import state, { InvestmentState } from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const investmentsModule: Module<InvestmentState, StateInterface> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}

export default investmentsModule
